import { createRoute } from "@tanstack/react-router";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Ellie Hernandez",
    title: "FP Wedding Ring Channel Champion",
    ownerId: "70e6075c-d014-4f9e-8aa8-9babd56cc82d",
    image: "/assets/headshots/ellie-hernandez.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/consultants/wedding-ring",
  component: () => <TeamRosterPage team="Wedding Ring Consultants" members={members} />,
});
